<!--
  创建时间：2024/10/30 上午11:25
  创建人：toyeh
  文件描述：SideNav
-->

<template>
  <div class="def-w">
    <div class="flex">

      <div class="left">
        <div class="left-img">
          <img :src="menuBgImg" alt="">
          <h3 class="left-title">{{ parentInfo.name }}</h3>
        </div>
        <ul class="cate-list">
          <li v-for="item in cateList" :key="item.code" class="cate-item" @click="selectCate(item.code)">
            <div class="cate-title" :class="{'active': code === item.code}">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <div class="right flex-1">
        <router-view :cate-info="curCateInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import { TOP_NAV_MENU_CODE } from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "SideNav",
  components: {},
  props: {
  }, data() {
    return {
      code: "",
      parentInfo: {},
      cateList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["allMenusTree"]),
    curCateInfo() {
      return this.cateList?.find(item => item.code === this.code) ?? this.parentInfo
    },
    menuBgImg() {
      switch (this.parentInfo.code) {
        case TOP_NAV_MENU_CODE.PLATFORM_INFO:
          // 平台信息
          return require("@/assets/images/side-nav/ptgl.jpg")
        case TOP_NAV_MENU_CODE.SERVICE_GUIDE:
          // 服务指南
          return require("@/assets/images/side-nav/fwzn.jpg")
        case TOP_NAV_MENU_CODE.ABOUT_US:
          // 关于我们
          return require("@/assets/images/side-nav/gywm.jpg")
        case TOP_NAV_MENU_CODE.LAWS_POLICY:
          // 政策法规
          return require("@/assets/images/side-nav/zcfg.jpg")
        default:
          return require("@/assets/images/side-nav/default.jpg")
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.params
    this.code = params.code
    this.menuId = this.$getMenuIdByCode(params.code || TOP_NAV_MENU_CODE.NEWS_INFO)
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 初始化
    init() {
      const item = this.allMenusTree.find(item => item.id === this.menuId)
      if (item) {
        this.parentInfo = item
        const children = item.children
        this.cateList = children && children.length > 0 ? children : [this.parentInfo]
      } else {
        for (const item of this.allMenusTree) {
          if (item.children) {
            const parent = item.children.find(item => item.id === this.menuId)
            if (parent) {
              this.parentInfo = item
              this.cateList = item.children
              break
            }
          }
        }
      }
    },
    // 选择分类
    selectCate(code) {
      this.code = code
      this.$router.replace({
        path: this.curCateInfo.path
      })
    }
  }
};
</script>

<style scoped lang="scss">
.left{
	width: 278px;
	.left-img{
		position: relative;
		img{
			display: block;
			width: 100%;
		}
		.left-title{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translate(0, -50%);
			color: #fff;
			font-size: 36px;
			text-align: center;
		}
	}
	.cate-list{
		border: 1px solid #ddd;
		padding: 0 20px;
		.cate-item{
			padding: 6px 0;
			font-size: 14px;
			cursor: pointer;
			.cate-title{
				height: 38px;
				line-height: 38px;
				text-align: center;
				&:hover{
					background-color: $--color-primary;
					color: #fff;
				}
			}
			.active{
				background-color: $--color-primary;
				color: #fff;
			}
		}
		.cate-item + .cate-item{
			border-top: 1px solid #ddd;
		}
	}
}
.right{
	width: 0;
	margin-left: 40px;
}

</style>
